'use client';
import React from 'react';

import 'dayjs/locale/zh-cn';
import { AntdRegistry } from '@ant-design/nextjs-registry';
import { ConfigProvider } from 'antd';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes/dist/types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from '@whelk/store';
import {
  disableScaleEventIOS,
  fixOnVisibilityChange,
  fixVhHeightInSafari,
} from '@whelk/utils/src/fxxkSafari';
import i18n from '@whelk/utils/src/i18n';
import { isBrowser } from '@whelk/utils/src/next';
import { initSensors } from '@whelk/utils/src/track';

import './style.scss';

export const ThemeProvider = (props: ThemeProviderProps): React.JSX.Element => {
  return NextThemesProvider(props) as React.JSX.Element;
};

if (isBrowser) {
  fixVhHeightInSafari();
  disableScaleEventIOS();
  fixOnVisibilityChange();
  initSensors();
}

export default function App({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AntdRegistry>
          <ConfigProvider theme={{ token: { colorPrimary: '#FE3666' } }}>
            <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true}>
              <I18nextProvider i18n={i18n}>
                <DndProvider backend={HTML5Backend}>{children}</DndProvider>
              </I18nextProvider>
            </ThemeProvider>
          </ConfigProvider>
        </AntdRegistry>
      </PersistGate>
    </Provider>
  );
}
